import { call, put, select } from 'redux-saga/effects';

import { createFactoryMembershipRequest, deleteFactoryMembershipRequest } from '../requests';
import { pathSelector } from '../../../selectors';
import { createFactoryMembership, deleteFactoryMembership } from '../../../actions';
import { createLocalId } from '../../../utils/local-id';

export function* createFactoryMembershipService(factoryId, data) {
  const localId = yield call(createLocalId);

  yield put(
    createFactoryMembership({
      ...data,
      factoryId,
      id: localId,
    }),
  );

  yield call(createFactoryMembershipRequest, factoryId, localId, data);
}

export function* createMembershipInCurrentFactoryService(data) {
  const { factoryId } = yield select(pathSelector);

  yield call(createFactoryMembershipService, factoryId, data);
}

export function* deleteFactoryMembershipService(id) {
  yield put(deleteFactoryMembership(id));
  yield call(deleteFactoryMembershipRequest, id);
}
